/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner } from './FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner';
import {
    FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerFromJSON,
    FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerFromJSONTyped,
    FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerToJSON,
    FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerToJSONTyped,
} from './FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner';
import type { FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification } from './FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification';
import {
    FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationFromJSON,
    FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationFromJSONTyped,
    FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationToJSON,
    FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationToJSONTyped,
} from './FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification';

/**
 * 
 * @export
 * @interface FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner
 */
export interface FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    practitioner_id: string;
    /**
     * 
     */
    updated_at: Date;
    /**
     * 
     */
    role: FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerRoleEnum | null;
    /**
     * 
     */
    effective_date?: string | null;
    /**
     * 
     */
    source_document?: string | null;
    /**
     * 
     */
    practitioner: FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner;
    /**
     * 
     */
    pecos_verification?: FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification;
    /**
     * 
     */
    last_checked_at: string | null;
}


/**
 * @export
 */
export const FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerRoleEnum = {
    InitialReferring: 'INITIAL_REFERRING',
    F2FEncounter: 'F2F_ENCOUNTER',
    F2FCertifying: 'F2F_CERTIFYING',
    PlanOfCareSigning: 'PLAN_OF_CARE_SIGNING',
} as const;
export type FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerRoleEnum = typeof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerRoleEnum[keyof typeof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerRoleEnum];


/**
 * Check if a given object implements the FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner interface.
 */
export function instanceOfFindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner(value: object): value is FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('practitioner_id' in value) || value['practitioner_id'] === undefined) return false;
    if (!('updated_at' in value) || value['updated_at'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('practitioner' in value) || value['practitioner'] === undefined) return false;
    if (!('last_checked_at' in value) || value['last_checked_at'] === undefined) return false;
    return true;
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerFromJSON(json: any): FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner {
    return FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerFromJSONTyped(json, false);
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'practitioner_id': json['practitioner_id'],
        'updated_at': (json['updated_at'] == null ? json['updated_at'] : parseDateTime(json['updated_at'])),
        'role': json['role'],
        'effective_date': json['effective_date'] === undefined ? undefined : json['effective_date'] === null ? null : json['effective_date'],
        'source_document': json['source_document'] === undefined ? undefined : json['source_document'] === null ? null : json['source_document'],
        'practitioner': FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerFromJSON(json['practitioner']),
        'pecos_verification': json['pecos_verification'] == null ? undefined : FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationFromJSON(json['pecos_verification']),
        'last_checked_at': json['last_checked_at'],
    };
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerToJSON(json: any): FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner {
    return FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerToJSONTyped(json, false);
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerToJSONTyped(value?: FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'practitioner_id': value['practitioner_id'],
        'updated_at': value['updated_at'] == null ? value['updated_at'] : serializeDateTime(value['updated_at']),
        'role': value['role'],
        'effective_date': value['effective_date'],
        'source_document': value['source_document'],
        'practitioner': FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerToJSON(value['practitioner']),
        'pecos_verification': FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationToJSON(value['pecos_verification']),
        'last_checked_at': value['last_checked_at'],
    };
}

